import { LucideIcon, Puzzle } from 'lucide-react';

// Les icones ne voyagent pas dans le manifeste JSON : chaque remote reference
// une cle de ce registre via son champ `icon`. Cle absente ou inconnue -> Puzzle.
const remoteNavIcons: Record<string, LucideIcon> = {};

function getRemoteNavIcon(icon?: string): LucideIcon {
  return (icon && remoteNavIcons[icon]) || Puzzle;
}

export { getRemoteNavIcon };
